module.exports = __webpack_public_path__ + "img/dark_right_item_bg.12b2c0de.png";